import { useSEO } from '@/hooks/useSEO';

interface SEOProps {
  title: string;
  description?: string;
  keywords?: string;
  path?: string;
  image?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEO({ title, description, keywords, path, image, schema }: SEOProps) {
  useSEO({ title, description, keywords, path, image });

  if (!schema) return null;

  const schemas = Array.isArray(schema) ? schema : [schema];

  return (
    <>
      {schemas.map((s, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(s),
          }}
        />
      ))}
    </>
  );
}